import { ISortQuery } from '@inmarsat-itcloudservices/ui';
import { IDetails } from './customer.model';

export interface ICorporateGroupsBase {
  legalEntityCode: string;
  collectorCode?: string;
  collectorDescription?: string;
  tier: string;
  endDate?: string;
  status?: CorporateGroupStatus;
}

export interface ICorporateGroups extends ICorporateGroupsBase {
  details: IDetails;
}

export interface ICorporateDetails extends ICorporateGroupsBase {
  details: IDetails;
  createdDate: string;
  createdBy: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  collectorDescription?: string;
}

export interface ICorporateGroupsQuery extends ISortQuery {
  region?: string;
  tier?: string;
  corporateGroups?: string;
  legalEntityCode?: string;
  collectorCode?: string;
  status?: CorporateGroupStatus;
  active?: boolean;
  sort?: string;
  multiSearch?: boolean;
}

export interface ICorporateGroupConfig {
  legalName?: string;
  tier?: string;
  collectorCode?: string;
  creditRegion?: string;
  collectorDescription?: string;
}

export enum CorporateGroupStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}
